import { Devices } from '@common/constants/shared';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type State = {
  deviceSelected: Devices;
};

const initialState: State = {
  deviceSelected: Devices.IPHONE_PRO,
};

const appSlice = createSlice({
  name: 'action',
  initialState: initialState,
  reducers: {
    setDeviceSelected: (state: State, action: PayloadAction<Devices>) => {
      state.deviceSelected = action.payload;
    },
  },
});

export const { setDeviceSelected } = appSlice.actions;
export default appSlice.reducer;
